import React, { useEffect, useState } from "react";
import { useFilterTickets, useGetTicketsList } from "../../hooks/useManagement";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { Table } from "../Table/Table";
import { TicketsListStyle } from "./TicketsListStyle";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../Loadings/LoadingTable";
import Button from "../Button/Button";
import { Badge } from "react-bootstrap";
import Typography from "../Typography/Typography";
import { AiOutlineHistory } from "react-icons/ai";
import { TicketReferencesModal } from "../Dialog/TicketReferencesModal";
const TicketsList = ({ publicTicket }) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [referal, setReferal] = useState();
  const [Search, setSearch] = useState("");
  const [key, setKey] = useState(null);
  // const { data: ticketsList, isLoading } = useGetTicketsList({ key });
  const {
    data: ticketsList,
    isLoading,
    hasNextPage,
    fetchNextPage,
  } = useGetTicketsList({ key });

  useEffect(() => {
    let fetching = false;
    const onScroll = async (event) => {
      const { scrollHeight, scrollTop, clientHeight } =
        event.target.scrollingElement;
      if (!fetching && scrollHeight - scrollTop <= clientHeight * 2.5) {
        fetching = true;
        if (hasNextPage) await fetchNextPage();
        fetching = false;
      }
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [fetchNextPage, hasNextPage]);
  const ticketsListHeaderTitle = [
    "ردیف",
    "شماره تیکت",
    "موضوع",

    "تاریخ",
    "وضعیت",
    "ارسال کننده",
    "گیرنده",
    "دپارتمان",
    "ارجاعات",
  ];
  let itemNumber = 0;
  const items = ticketsList?.pages?.map((page) => {
    return page.data?.Tickets?.filter((ticket) => {
      if (Search === "") {
        return ticket;
      } else if (ticket.SubjectTicket.includes(Search)) {
        return ticket;
      }
    }).map((ticket, index) => {
      itemNumber++;
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold d-block fs-7">
              {itemNumber}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold d-block fs-7">
              {ticket?.IdTicket}{" "}
              <span>
                {ticket.unreadMessageCount >= 1
                  ? `(${ticket?.unreadMessageCount})`
                  : ""}
              </span>
            </span>
          </td>
          <td>
            <Link
              to={
                !publicTicket
                  ? `/dashboard/management/tickets/ticketChat/${ticket.IdTicket}`
                  : `/dashboard/tickets/ticketChat/${ticket.IdTicket}`
              }
            >
              <span
                className="text-muted fw-bold d-block fs-7"
                style={{ cursor: "pointer" }}
              >
                {ticket.SubjectTicket}
              </span>
            </Link>
          </td>

          <td>
            <span className="text-muted fw-bold d-block fs-7">
              {MiladiToShamsi(ticket.created_at)}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold d-block fs-7">
              <span
                className={`text-muted fw-bold text-muted d-block fs-7`}
                style={{ fontSize: "16px" }}
              >
                <Badge className="p-1 badging" bg={ticket.status.color}>
                  {ticket.status.text}
                </Badge>
              </span>
            </span>
          </td>

          <td>
            <span className="text-muted fw-bold d-block fs-7">
              {(ticket.creator.FirstName ? ticket.creator.FirstName : "") +
                " " +
                (ticket.creator.LastName ? ticket.creator.LastName : "")}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold d-block fs-7">
              {(ticket.target_user.FirstName
                ? ticket.target_user.FirstName
                : "") +
                " " +
                (ticket.target_user.LastName
                  ? ticket.target_user.LastName
                  : "")}
            </span>
          </td>
          <td>
            <span className={`text-muted fw-bold text-muted d-block fs-7`}>
              <Typography
                className={`text-${ticket.department.ColorDepartment}`}
              >
                {ticket.department.NameDepartment}
              </Typography>
            </span>
          </td>
          <td>
            <span className={`text-muted fw-bold text-muted d-block fs-7`}>
              {ticket.IdLastUserReference !== null &&
              ticket.IdLastReferee !== null ? (
                <Button
                  className={"bg-secondary"}
                  small="fit-content"
                  onclick={() => {
                    setShow(true);
                    setReferal(ticket.referenceHistory);
                  }}
                >
                  <AiOutlineHistory color="#fff" />
                </Button>
              ) : null}
            </span>
          </td>
        </tr>
      );
    });
  });
  console.log(items);
  const tabs = ticketsList?.data?.statuses.map((status) => {
    return (
      <Button
        className="px-3 mx-2"
        small="fit-content"
        bgColor={`${status.color}`}
        color="#fff"
        onclick={() => setKey(status.key)}
      >
        {status.text}
      </Button>
    );
  });
  return (
    <TicketsListStyle>
      <Table
        className="mt-3"
        setSearch={setSearch}
        headerTitle={ticketsListHeaderTitle}
        items={items ? items : <Loading />}
        title={`تیکت ها ${itemNumber}`}
        detailOrder={
          <Button
            bgColor="#009ef7"
            size="14px"
            small="fit-content"
            color="#fff"
            className="me-3"
            onclick={() => {
              if (!publicTicket) {
                navigate("/dashboard/management/tickets/AddTicket");
              } else {
                navigate("/dashboard/ticket/AddTicket");
              }
            }}
          >
            تیکت جدید
          </Button>
        }
        tabs={
          <div className="px-3 my-3 d-flex">
            <Button
              className="px-3 mx-2 border"
              color="#000"
              small="fit-content"
              onclick={() => setKey(null)}
            >
              همه
            </Button>
            {tabs}
          </div>
        }
      />

      <TicketReferencesModal
        show={show}
        handleClose={() => setShow(false)}
        referal={referal}
      />
    </TicketsListStyle>
  );
};

export default TicketsList;
